import React, { useEffect, useState, useMemo } from 'react';
import { getAdminRoles, deleteAdminRole,toggleRoleStatus } from '../../services/adminApi'; // Assuming these API functions exist
import ReusableAdminTable from './ReusableAdminTable'; // Adjust path
import { Link,useNavigate } from 'react-router-dom';
import { deleteRoleApi} from '../../services/api';

// UI & Icons
import { Button, Badge } from 'react-bootstrap';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const AdminRoleList = () => {
    // State for roles
    const [roles, setRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
     const navigate = useNavigate();

    // Fetching logic for roles
    const loadRoles = async () => {
        setIsLoading(true);
        try {
            const res = await getAdminRoles();
            setRoles(res.data);
        } catch (error) {
            console.error("Error fetching roles", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadRoles();
    }, []);

    const handleEdit = (localId) => {
        navigate(`/admin/post-roles/${localId}`);
    };

    const handleDelete = async (localId, roleName) => {
        if (window.confirm(`Are you sure you want to delete the role "${roleName}"?`)) {
          try {
            await deleteRoleApi(localId);
            alert('Role deleted successfully!');
            loadRoles(); 
          } catch (err) { 
            alert('Failed to delete role.'); 
          }
        }
    };

    const handleAddNew = () => {
        console.log("Navigate to Add Role page");
         navigate('/admin/post-roles');
    };

    const handleToggleStatus = async (id, role) => {
        try {
            const res = await toggleRoleStatus(id);

            // ❌ BLOCK CASE → popup
            if (res.data.block) {
                window.alert(res.data.message);
                return;
            }

            // 🔴 ROLE DEACTIVATE
            if (role.status === 'active') {
                const confirmDeactivate = window.confirm(
                    "Do you want to deactivate this role?"
                );

                if (!confirmDeactivate) return;
            } 
            // 🟢 ROLE ACTIVATE
            else {
                const confirmActivate = window.confirm(
                    "Do you want to activate this role?"
                );

                if (!confirmActivate) return;
            }

            // 🔥 Reload
            loadRoles();

        } catch (err) {
            alert("Something went wrong");
        }
    };

    // Column definitions specific to Roles
    const columns = useMemo(() => [
        { accessorKey: 'id', header: 'ID' },
        { accessorKey: 'role_name', header: 'Role Name' },
        { accessorKey: 'project.project_name', header: 'Project' }, // Assumes backend JOINs this data
        { accessorKey: 'required_gender', header: 'Gender' },
        { accessorKey: 'required_age', header: 'Age Range' },
        {
            accessorKey: 'status',
            header: 'Status',
            cell: info => (
                <Badge bg={info.getValue() === 'Open' ? 'success' : 'danger'}>{info.getValue()}</Badge>
            )
        },
        {
            id: 'toggle',
            header: 'Control',
            cell: (info) => {
                const status = info.row.original.status;

                return (
                    <Button
                        size="sm"
                        variant={status === 'active' ? 'success' : 'secondary'}
                        // onClick={() => handleToggleStatus(info.row.original.id)}
                        onClick={() => handleToggleStatus(info.row.original.id, info.row.original)}
                    >
                        {status === 'active' ? 'Deactivate' : 'Activate'}
                    </Button>
                );
            }
        },
        {
            id: 'actions',
            header: 'Actions',
            cell: (info) => {
                    const role = info.row.original;
                    return (
                      <div className="d-flex justify-content-center gap-2">
                        <Button variant="link" className="p-0 text-info" title="Edit" onClick={() => handleEdit(role.id)}>
                          <FiEdit />
                        </Button>
                        <Button variant="link" className="p-0 text-danger" title="Delete" onClick={() => handleDelete(role.id, role.roleName)}>
                          <FiTrash2 />
                        </Button>
                      </div>
                    );
                  },
        }
    ], []);

    return (
        <ReusableAdminTable
            data={roles}
            columns={columns}
            isLoading={isLoading}
            title="Role Management"
            onAddNew={handleAddNew}
            addNewButtonText="Add Role"
            searchPlaceholder="Search roles..."
            exportCsvFilename="roles.csv"
        />
    );
};

export default AdminRoleList;